import { createContext, useState, type PropsWithChildren, useContext } from "react";
import { ToastContainer } from "react-toastify";

import PageLoading from "../../pages/commons/PageLoading";

interface IUtilsContext {
    isLoading: boolean;
    setIsLoading: (value: boolean) => void;
}

export const UtilsContext = createContext({} as IUtilsContext);

export const useUtils = () => useContext(UtilsContext);

export default function Utils({ children }: PropsWithChildren<unknown>) {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <UtilsContext.Provider
            value={{
                isLoading,
                setIsLoading,
            }}
        >
            <PageLoading open={isLoading} />
            <ToastContainer />
            {children}
        </UtilsContext.Provider>
    );
}
